// @ngInject
function MaingroupsApiService(ResourcesService) {

    var endpoint = 'maingroups';

    return {
        getMainGroups: ResourcesService.apiFactory.get(endpoint),
        getMainGroup: ResourcesService.apiFactory.get(endpoint),
        getSubCategories: ResourcesService.apiFactory.get(endpoint + '/subcategories'),
        getIntrastats: ResourcesService.apiFactory.get(endpoint + '/intrastats'),
        getSalesChannels: ResourcesService.apiFactory.get(endpoint + '/saleschannels'),
        getDepartments: ResourcesService.apiFactory.get(endpoint + '/departments'),
        getBrands: ResourcesService.apiFactory.get(endpoint + '/brands'),
        getVariantGroups: ResourcesService.apiFactory.get(endpoint + '/variantgroups'),
        getVariants: ResourcesService.apiFactory.get(endpoint + '/variants'),
        getBusinessAreas: ResourcesService.apiFactory.get(endpoint + '/businessareas'),
        getTenantConfig: ResourcesService.apiFactory.get(endpoint + '/tenantconfig'),
        createItemGroups: ResourcesService.apiFactory.update(endpoint + '/createitemgroups','MainGroup'),
        createMainGroup: ResourcesService.apiFactory.create(endpoint,'MainGroup'),
        updateMainGroup: ResourcesService.apiFactory.update(endpoint,'MainGroup')
    };

}


angular.module('maingroups.api', [])
  .factory('MaingroupsApiService', MaingroupsApiService);
